const makeClass = (...classes: string[]) => classes.filter(Boolean).join(' ');

export default makeClass;
